import type { FaireProductEntity } from "../../entity_types/product";

export const p_tgxvq8kug9: FaireProductEntity = {
  token: "p_tgxvq8kug9",
  type: "product",
  name: "Off Leash Little Pouch",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/457930ac392a6a279e9b966a87db59f033e525e9fc91d3e83a69aede439f5888.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7850b61ee326270a25ca93c8c879fdc16135f5e4fb76ef86b61f20623c03fd99.jpeg",
    "https://cdn.faire.com/fastly/fe241d06ac87630669a7ad1f611cc1b2c736ce1df01c008d343e2c1aeba27593.jpeg",
    "https://cdn.faire.com/fastly/a28bccf2cf9a8b3347b497d2a3dda74ccf3acde0667ecffe1fe4b3889fe442b9.jpeg",
    "https://cdn.faire.com/fastly/34841fa5f25d09cdf13ec624c75651efa31ebee43d703dc5e34eef6811321ac8.png",
  ],
  priceDollars: 8,
  description:
    'What other little product balances both “love” and “need” so perfectly? A pouch! Just the right size for all the small things that roam free in your bag, these charming zips make organizing a treat. And, with designs that coordinate beautifully with Little Notes® and other E. Frances favorites, they’re also perfect for gifting.\n\nEach pouch comfortably fits 2 packs of Little Notes® plus a set of Little Colored Pencils, making it a must-have for your Little Notes® collection.\n\nMeasuring 7" x 5" with a bottom gusset, matte gold zipper and pull, brilliant color and high-quality stitching—these are NICE!',
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:24.331Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
